import React, { useEffect, useState, useMemo, useRef } from 'react';
import Carousel from 'react-material-ui-carousel'
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { Paper, Box, Typography, Portal } from '@mui/material'
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// import ordernow from '../../assets/images/btn_order_now.png';
import { styled } from '@mui/material/styles';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Axios } from '../../api/axios';
import { useInfoStore } from '../../store/userInfo';
import { isBrowser } from 'react-device-detect';
import { TimerState, useMenuStore } from '../../store/menuState';
import { useWindowDimensions } from '../../App';
import { useOrderStore } from '../../store/order';
import { logger } from '../../utils/logger';
import { logging } from '../../services/setting.service';
// import { IAyceStatus } from '../main/AyceMenu';
              
// 플랫폼 확인 Android
const isAndroid = /Android/i.test(navigator.userAgent);

const LazyPicture = styled(LazyLoadImage)`
  object-fit: cover;
  width: ${({ width }) => (width ? `${width}` : "100%")};
  height: ${({ width }) => (width ? `${width}` : "100%")};
  border-radius: '0px';

  &.lazy-load-image-background.opacity {
    background-image: none !important;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &.lazy-load-image-background.opacity.lazy-load-image-loaded {
    opacity: 1;
  }
`;
const IMAGE_URL = process.env.REACT_APP_S3_IMAGE_PAPH;
const HorizontalCarousel: React.FC = () =>
{
  const navigate: NavigateFunction = useNavigate();
  const { userInfo, tableInfo } = useInfoStore();
  const { setPromotionList } = useMenuStore();
  const { selectedAyce } = useOrderStore()
  const storeId = userInfo?.storeId;
  const isAyce = userInfo?.isAyce;
  const { width, height } = useWindowDimensions();
  const [items, setItems] = useState<any[]>([]);
  
  // const [tableAyceStatus, setTableAyceStatus] = useState({currentAdults: 0, currentChildren: 0, tableStatusId: 0} as IAyceStatus);

  // useEffect(() => {
  //   const eventSourceInitDict = {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Access-Control-Allow-Origin': '*',
  //       ...authHeader()
  //     },
  //     heartbeatTimeout: 100000
  //   };
  //   try{
  //     const es = new EventSourcePolyfill(
  //       `${process.env.REACT_APP_URI}sse/users?storeId=${storeId}&tableId=${tableInfo.id}`,
  //       eventSourceInitDict
  //     );
  //
  //     es.onopen = () => console.log(">>> Connection promotion!");
  //     es.onerror = (e) => console.log("ERROR!", e);
  //     es.onmessage = (e) => {
  //       // console.log("es >>>", e.data);
  //       const esData = JSON.parse(e.data);
  //       switch (esData.type) {
  //
  //         case 'TABLE_STATUS':
  //           setTableAyceStatus(esData.payload)
  //           console.log(esData.payload)
  //           if(isAyce && (esData.payload.tableStatusId <= 2)) {
  //             resetMenu()
  //             resetOrderCart()
  //             navigate('/aycemenu')
  //           }
  //           break;
  //         case 'AYCE_OCCUPANCY' :
  //           if(isAyce) {
  //             if(esData.payload?.currentAdults + esData.payload?.currentChildren > 0)
  //               navigate('/aycemenu')
  //           }
  //         break;
  //         default:
  //           return;
  //       }
  //     };
  //     return () => es.close();
  //   } catch(e) {
  //     console.log(e)
  //   }
  //
  // }, [storeId]);

  const getLists = async () => {
    try {
      const response = await Axios({
        method: 'GET',
        url: `advertisements/promotions/stores/${storeId}`
      });
      logger.debug('Promotion data received:', {
        count: response.data.length,
        data: response.data
      });
      if (storeId) logging('promotion getList', storeId, tableInfo.id);
      setItems(response.data);
      setPromotionList(response.data.length);
      return response.data;
    } catch (error) {
      logger.error('Failed to fetch promotions:', error);
      return [];
    }
  }
  
  const { data } = useQuery({ 
		queryKey: [`promotions`, storeId ], 
		queryFn: getLists,  
		enabled: storeId !== 0, 
  })

  useEffect(() => {
    if (!data) return;
    logger.debug('Promotion data changed:', {
      length: data.length,
      isAyce,
      selectedAyce
    });
    // 프로모션 데이터가 없어도 기본 프로모션 이미지를 보여주므로 navigate하지 않음
    // if (data.length === 0) {
    //   if (isAyce && !selectedAyce) {
    //     navigate('/aycemenu');
    //   } else {
    //     navigate('/main');
    //   }
    // }
  }, [data, isAyce, selectedAyce]);

  if(!data) return(<></>)

  // 프로모션 데이터가 있으면 data를 사용하고, 없으면 기본 슬라이드 생성 (type: 'default' 로 구분)
  const slides = data.length > 0 ? data : [{ id: 'default', type: 'default', mediaPath: '' }];

  return (
      <Carousel sx={{width: '100vw', height: '100vh', borderRadius: 0, background: '#000'}}
        navButtonsAlwaysInvisible={true}
        fullHeightHover={false} 
        swipe={false}
        interval={10000}
        duration={600}
        animation={"slide"}
        cycleNavigation={true}
        indicators={false}>
          {
              slides.map( (item: any, i: any) => { return (
                  <Item key={i} item={item} />
              ) })
          }
      </Carousel>
  )
}

const Item = (props: any) => {
  const {item} = props;
  const { orientation } = useWindowDimensions();
  const { userInfo } = useInfoStore();
  const { resetOrderCart, selectedAyce, totalCount } = useOrderStore();
  const { promotionDao, totalOrderTimeLimit, remainingOrderTime: remaining, setIsIdle, setSelectedItem } = useMenuStore();
  const isAyce = userInfo?.isAyce;
  const queryClient = useQueryClient()
  const timerState = useMenuStore((s) => s.timerState);
  const base64CacheRef = useRef(new Map<string, string>());
  const [nativeImageVersion, setNativeImageVersion] = useState(0);

  // useEffect(() => {
  //   console.log('item', item)
  //   if(isAyce && totalOrderTimeLimit.useAyceTimeLimit && remaining <= 0) {
  //     setIsIdle(false)
  //     resetStatus()
  //   }
  // }, [item, isAyce, totalOrderTimeLimit.useAyceTimeLimit, timerState])
  /**
   * MIME 타입 추출 함수
   */
  const getMimeType = (imagePath: string): string => {
    const extension = imagePath.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      case "png":
        return "image/png";
      case "webp":
        return "image/webp";
      case "gif":
        return "image/gif";
      default:
        return "application/octet-stream"; // 기본 MIME 타입
    }
  };
  
  const TRANSPARENT_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
  const defaultImage = "/assets/images/no_image.png";
  const getBase64ImageSrc = (imagePath: string | null): string => {
    
    if (!imagePath) return "";
    
    if (base64CacheRef.current.has(imagePath)) {
      return base64CacheRef.current.get(imagePath)!;
    }
    setTimeout(() => {
      const base64Image = window.Android?.getImageAsBase64(imagePath);
      if (base64Image) {
        const mimeType = getMimeType(imagePath);
        const src = `data:${mimeType};base64,${base64Image}`;
        base64CacheRef.current.set(imagePath, src);
        setNativeImageVersion(v => v + 1);
      }
    }, 0);
    return TRANSPARENT_IMAGE;
  };

  /**
   * promotionDao를 ID 기준으로 매핑
   */
  const promotionMap = useMemo(() => {
    const map = new Map();
    promotionDao.forEach((promotion: any) => {
      map.set(promotion.id, promotion); // promotion.id를 키로 사용
    });
    return map;
  }, [promotionDao]);

  // 프로모션 데이터가 있을 경우 기존 로직, 없으면 기본 프로모션 이미지 사용
  let imageSrc = '';
  if(item.type === 'default') {
    // 기본 프로모션 이미지 경로
    imageSrc = process.env.PUBLIC_URL + '/assets/images/default_promotion_image.webp';
  } else {
    // promotionDao에서 item.id로 promotionItem 찾기
    const promotionItem = promotionMap.get(item.id);
    const webImagePath = IMAGE_URL + `/${item.mediaPath}`;
    const androidImagePath = promotionItem?.mediaPath ?? null;
    // Android 여부 판단 및 이미지 소스 결정
    // Android: getBase64ImageSrc(androidImagePath) / web: IMAGE_URL+`/${item.mediaPath}`
    imageSrc = isAndroid 
      ? (androidImagePath ? getBase64ImageSrc(androidImagePath) : webImagePath)
      : webImagePath;
  }

  const handleOrderNow = (e: { preventDefault: () => void; stopPropagation: () => void; }, item: { isSoldout: any; itemId: number; }) => {
    logger.debug('handleOrderNow')
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if(!item.isSoldout || (isAyce && selectedAyce && totalCount > 0) ) {
      setSelectedItem({itemId: item.itemId, categoryId: -1})
      queryClient.invalidateQueries({queryKey: ['detail', item?.itemId ]})
      // if (!isBrowser) {
      //   if (window.ReactNativeWebView !== undefined) {
      //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
      //   } else if(window.Android !== undefined){
      //     window.Android.postMessage(JSON.stringify({'type':'play'}));
      //   }
      // }
      setIsIdle(false)
      resetStatus()
      // navigate('/main');
    }
  }

  const handleExitPromotion = (e: { preventDefault: () => void; stopPropagation: () => void; }) => {
    logger.debug("exit promotion")
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsIdle(false)
    resetStatus()
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
  }

  const resetStatus = () => {
    resetOrderCart()
  }
  const remainMinus = Math.floor((remaining%3600)/60)
  const remainTotalMinutes = Math.floor(remaining / 60);
  return (
      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,  display: 'flex', justifyContent: 'center', alignItems: 'center',
        borderRadius: '0rem', background: '#000', cursor: 'pointer' }} onClick={(e) => {handleExitPromotion(e); }}>
        {isAyce && totalOrderTimeLimit.useAyceTimeLimit && timerState === TimerState.RUNNING && <Box 
        sx={{
            position: 'absolute',
            left: '50%',
            top: 0,
            transform: 'translateX(-50%)',
            backgroundColor: '#000',
            padding: '8px 24px',
            borderBottomLeftRadius: '12px',
            borderBottomRightRadius: '12px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            height: '6.1rem',
            zIndex: 10
        }}>
          <img 
            style={{ 
              width: '2.0rem', 
              height: '2.0rem', 
            }}
            src={process.env.PUBLIC_URL+'/assets/images/aycetimer.svg'}
            alt="time"
          />
          <Typography sx={{ml: '0.8rem', fontSize: '16px', fontWeight: '500', lineHeight: '2.0rem', color: '#bbb', textWrap: 'nowrap', letterSpacing: '0.08rem'}}>Order Time Out</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: '2rem', height: '2.4rem'}}>
            <Typography sx={{fontSize: '20px', fontWeight: '600', textAlign: 'center', borderRadius: '.8rem', color: remainTotalMinutes <= 11 ? '#ff1f00' : '#fff'}}>{String(Math.floor(remaining/3600)).padStart(2, '0')} : {String(remainMinus).padStart(2, '0')}</Typography>
          </Box>
        </Box>}
        <LazyPicture style={{width: '100vw'}}
          key={item.id} 
          // src={IMAGE_URL+`/${item.mediaPath}`}
          src={imageSrc}
          effect='opacity'
        />
   
        {/* {currentPage !== "ayce" && item.type === 'promotionMenu' ?  
          <Box sx={ styles.orderNowContainer }  onClick={(e) => handleOrderNow(e, item)}>
              <img style={{width: '30rem', height: '16rem'}}
                src={process.env.PUBLIC_URL+'/assets/images/btn_order_now.png'}
                alt='ordernow'
              />
              <Typography sx={[{...styles.orderNowText}]}>Add to Cart</Typography>

          </Box> : <></>
        } */}
      </Box>
  )
}
const styles = {
  orderNowContainer : {
    position: 'absolute',
    right : '8.0rem',
    bottom: 0,
    zIndex: 998,
    cursor: 'pointer'
  },
  orderNowText: {
    position: 'absolute',
    color: '#fff',
    fontSize: '2.3rem',
    width: '20rem',
    textAlign: 'center',
    fontWeight: '700',
    top: '4.8rem',
    left: '8.6rem',
    zIndex: 1,
  },
  itemImage: {
    resizeMode: 'cover',
  },
}
export default HorizontalCarousel; 
